import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../store/hooks";
import FullPageLoader from "../components/FullPageLoader";
import { AppRoutes } from "../routes";

const PrivateRoutes: React.FC = () => {
	const { currentUser, loading } = useAuth();

	if (loading) {
		return <FullPageLoader />;
	}

	if (!currentUser) {
		return <Navigate to={AppRoutes.signIn} replace />;
	}

	return <Outlet />;
};

export default PrivateRoutes;